export const formatReportPercentage = (value: number): string => {
  const rounded = Math.round(value * 100) / 100;

  return String(rounded);
};
